import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, Divider, makeStyles, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@material-ui/core';
// import { useLocation, useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { getUsersforDOA } from '../../ReduxStore/AssetDisposalSlice';
import { useNavigate } from 'react-router-dom';
import { deleteUser } from '../../ReduxStore/MastertableSlice';

const useStyles = makeStyles((theme) => ({
    checkpoint_box: {
        margin: '0 auto',
        maxWidth: '950px',
        marginBottom: theme.spacing(3),
        padding: '20px',
        border: '2px solid black',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
}));


const ViewUserList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' },
        { label: 'User Management', href: '/user-management' }
    ];
    // const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    // const [loadingStates, setLoadingStates] = useState([]);
    const [users, setUsers] = useState([]);

    const handleDelete = async (index) => {

        const Name = users[index].name;
        const userId = users[index].id;

        // Show confirmation alert
        const userConfirmed = window.confirm(
            `Do you want to delete"${Name}"?`
        );

        if (userConfirmed) {
            try {
                const action = dispatch(deleteUser(userId));
                const res = await action.unwrap();
                if (res.StatusCode === 200) {
                    getUserList();
                    toast.success("User Deleted Successfully!")
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            }
        }

    }

    const handleEdit = (item) => {
        navigate(`/user-management/add-user/${item.id}`)
    }


    const getUserList = async () => {
        try {
            const action = dispatch(getUsersforDOA(`?customerID=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            if (res.result) {
                // Filter out inactive users
                const activeUsers = res.result.filter(user => user.status === "active");
                setUsers(activeUsers);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await getUserList();
            setLoading(false);
        };
        fetchData();
    }, [])





    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        User List
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="View Users" />
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Phone</TableCell>
                                            <TableCell>Email</TableCell>
                                            <TableCell>Department</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {users.map((contact, index) => {
                                            // Extract the department name from the departments object
                                            const departmentName = Object.values(contact.departments || {})[0]?.name || 'N/A';

                                            return (
                                                <TableRow key={index}>
                                                    {/* <TableCell>
                                                        <button
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                color: '#3f51b5',
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </button>
                                                    </TableCell> */}
                                                    <TableCell>{contact.name}</TableCell>
                                                    <TableCell>{contact.phoneNo}</TableCell>
                                                    <TableCell>{contact.email}</TableCell>
                                                    <TableCell>{departmentName}</TableCell>
                                                    <TableCell>
                                                        {/* Action Buttons */}
                                                        <button
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                color: '#3f51b5',
                                                                marginRight: '8px',
                                                            }}
                                                            onClick={() => handleEdit(contact)}
                                                        >
                                                            <EditIcon />
                                                        </button>
                                                        <button
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                cursor: 'pointer',
                                                                color: 'red',
                                                            }}
                                                            onClick={() => handleDelete(index)}
                                                        >
                                                            <DeleteIcon />
                                                        </button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Box>


                {/* <Box className={classes.checkpoint_box}>
                    <Grid container spacing={3} className="checkpoint-header" alignItems="center">
                        <Grid item xs={2}>
                            <h3>Name</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>User Name</h3>
                        </Grid>
                        <Grid item xs={4}>
                            <h3>Email</h3>
                        </Grid>
                        <Grid item xs={2}>
                            <h3>Phone No.</h3>
                        </Grid>
                    </Grid>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    {users && users.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={2}>
                                        {item.name}
                                    </Grid>
                                    <Grid item xs={2}>
                                        {item.username}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {item.email}
                                    </Grid>
                                    <Grid item xs={2}>
                                        {item.phoneNo}
                                    </Grid>
                                </Grid>
                                <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                            </React.Fragment>
                        );
                    })}
                </Box> */}

            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default ViewUserList;
